/* BDF HEADER — canonical controller */
(function(){
  'use strict';

  var collectionRoutes={
    '/collections/vetements':'/collections/vetements-bdf',
    '/collections/t-shirts':'/collections/t-shirts-bdf',
    '/collections/sweats':'/collections/sweats-bdf',
    '/collections/shorts':'/collections/shorts-bdf',
    '/collections/debardeurs':'/collections/debardeurs-bdf',
    '/collections/accessoires':'/collections/accessoires-bdf',
    '/collections/casquettes':'/collections/casquettes-bdf',
    '/collections/patchs':'/collections/patchs-bdf',
    '/collections/stickers':'/collections/stickers-bdf'
  };
  var legacyCopyRoutes={
    '/collections/vetements-copie':'/collections/vetements-bdf',
    '/collections/t-shirts-copie':'/collections/t-shirts-bdf',
    '/collections/sweats-capuche-militaire-et-sport-combat-copie':'/collections/sweats-bdf',
    '/collections/shorts-copie':'/collections/shorts-bdf',
    '/collections/debardeurs-sport-combat-mma-copie':'/collections/debardeurs-bdf',
    '/collections/accessoires-copie':'/collections/accessoires-bdf',
    '/collections/casquettes-trucker-brodees-3d-copie':'/collections/casquettes-bdf',
    '/collections/patchs-militaires-et-velcro-copie':'/collections/patchs-bdf',
    '/collections/cartes-cadeaux-copie':'/collections/cartes-cadeaux-bdf',
    '/collections/stickers-copie':'/collections/stickers-bdf'
  };

  function normalizePath(url){
    try{return new URL(url,window.location.origin).pathname;}
    catch(e){return url||'';}
  }

  function destinationForPath(path){return collectionRoutes[path]||legacyCopyRoutes[path]||'';}

  function routeCollection(){
    var path=window.location.pathname;
    var target=destinationForPath(path);
    if(!target||path===target)return;
    window.location.replace(target+(window.location.search||'')+(window.location.hash||''));
  }

  function normalizeCollectionLinks(root){
    if(!root)return;
    root.querySelectorAll('a[href]').forEach(function(link){
      var href=link.getAttribute('href');
      if(!href)return;
      var path=normalizePath(href);
      var replacement=destinationForPath(path);
      if(replacement)link.setAttribute('href',replacement+href.slice(path.length));
    });
  }

  function bindExclusiveAccordion(root,groupSelector,buttonSelector){
    if(!root)return;
    root.querySelectorAll(buttonSelector).forEach(function(button){
      if(button.dataset.bdfAccordionBound==='1')return;
      button.dataset.bdfAccordionBound='1';
      button.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        var group=button.closest(groupSelector);
        if(!group)return;
        var willOpen=!group.classList.contains('is-open');
        root.querySelectorAll(groupSelector+'.is-open').forEach(function(openGroup){
          if(openGroup===group)return;
          openGroup.classList.remove('is-open');
          var other=openGroup.querySelector(buttonSelector);
          if(other)other.setAttribute('aria-expanded','false');
        });
        group.classList.toggle('is-open',willOpen);
        button.setAttribute('aria-expanded',willOpen?'true':'false');
      });
    });
  }

  function focusables(root){
    if(!root)return[];
    return Array.prototype.slice.call(root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(node){
      return node.offsetParent!==null&&!node.hasAttribute('hidden');
    });
  }

  function init(){
    routeCollection();
    normalizeCollectionLinks(document);

    var shell=document.querySelector('.bdf-header-shell');
    var dotsTrigger=document.querySelector('[data-bdf-dots-trigger]');
    var dots=document.getElementById('bdfDotsMenu');
    var collectionRoot=document.querySelector('.bdf-collection-root');
    var collectionTrigger=collectionRoot&&collectionRoot.querySelector('.bdf-nav-parent');
    var collectionPanel=document.getElementById('bdfCollectionPanel');
    var mobile=document.getElementById('bdfMobileMenu');
    var overlay=document.querySelector('[data-bdf-overlay]');
    var mobileClose=mobile&&mobile.querySelector('.bdf-mobile-close');
    var previousMobileFocus=null;

    if(mobile){
      mobile.setAttribute('role','dialog');
      mobile.setAttribute('aria-modal','true');
      mobile.setAttribute('aria-label','Navigation mobile');
    }

    bindExclusiveAccordion(dots,'.bdf-dots-group','.bdf-dots-title[aria-expanded]');
    bindExclusiveAccordion(collectionPanel,'.bdf-collection-group','.bdf-collection-title[aria-expanded]');
    bindExclusiveAccordion(mobile,'.bdf-mobile-category','.bdf-mobile-category-title');

    function setMobile(open){
      if(!mobile||!overlay)return;
      if(open)previousMobileFocus=document.activeElement;
      mobile.classList.toggle('is-open',open);
      overlay.classList.toggle('is-open',open);
      mobile.setAttribute('aria-hidden',open?'false':'true');
      if(dotsTrigger)dotsTrigger.setAttribute('aria-expanded',open?'true':'false');
      document.documentElement.style.overflow=open?'hidden':'';
      if(open){
        window.setTimeout(function(){
          var first=focusables(mobile)[0]||mobileClose;
          if(first)first.focus();
        },0);
      }else{
        var target=previousMobileFocus&&typeof previousMobileFocus.focus==='function'?previousMobileFocus:dotsTrigger;
        previousMobileFocus=null;
        if(target)target.focus();
      }
    }

    if(dotsTrigger){
      dotsTrigger.addEventListener('click',function(event){
        if(window.innerWidth>768)return;
        event.preventDefault();
        event.stopPropagation();
        try{if(dots&&dots.matches(':popover-open'))dots.hidePopover();}catch(e){}
        setMobile(!mobile.classList.contains('is-open'));
      });
    }
    if(mobileClose)mobileClose.addEventListener('click',function(){setMobile(false);});
    if(overlay)overlay.addEventListener('click',function(){setMobile(false);});

    document.addEventListener('keydown',function(event){
      if(!mobile||!mobile.classList.contains('is-open'))return;
      if(event.key==='Escape'){
        event.preventDefault();
        setMobile(false);
        return;
      }
      if(event.key!=='Tab')return;
      var list=focusables(mobile);
      if(!list.length)return;
      event.preventDefault();
      var current=list.indexOf(document.activeElement);
      var nextIndex;
      if(current===-1)nextIndex=event.shiftKey?list.length-1:0;
      else if(event.shiftKey)nextIndex=(current-1+list.length)%list.length;
      else nextIndex=(current+1)%list.length;
      list[nextIndex].focus();
    });

    if(dots){
      dots.addEventListener('toggle',function(){
        if(dotsTrigger&&window.innerWidth>768)dotsTrigger.setAttribute('aria-expanded',dots.matches(':popover-open')?'true':'false');
      });
    }

    function positionCollectionPanel(){
      if(!collectionTrigger||!collectionPanel||window.innerWidth<=768)return;
      var rect=collectionTrigger.getBoundingClientRect();
      var panelWidth=Math.min(330,window.innerWidth-24);
      var center=rect.left+(rect.width/2);
      var half=panelWidth/2;
      var minCenter=12+half;
      var maxCenter=window.innerWidth-12-half;
      center=Math.max(minCenter,Math.min(center,maxCenter));

      collectionPanel.style.setProperty('position','fixed','important');
      collectionPanel.style.setProperty('top',(rect.bottom+7)+'px','important');
      collectionPanel.style.setProperty('left',center+'px','important');
      collectionPanel.style.setProperty('right','auto','important');
      collectionPanel.style.setProperty('bottom','auto','important');
      collectionPanel.style.setProperty('width',panelWidth+'px','important');
      collectionPanel.style.setProperty('margin','0','important');
      collectionPanel.style.setProperty('transform','translateX(-50%)','important');
      collectionPanel.style.setProperty('z-index','2147483001','important');
    }

    if(collectionPanel){
      collectionPanel.addEventListener('beforetoggle',function(event){if(event.newState==='open')positionCollectionPanel();});
      collectionPanel.addEventListener('toggle',function(){
        var open=collectionPanel.matches(':popover-open');
        if(collectionTrigger)collectionTrigger.setAttribute('aria-expanded',open?'true':'false');
        if(open)positionCollectionPanel();
      });
    }
    if(collectionTrigger)collectionTrigger.addEventListener('click',positionCollectionPanel);

    function refreshCollectionPosition(){
      if(!collectionPanel||window.innerWidth<=768)return;
      try{if(collectionPanel.matches(':popover-open'))positionCollectionPanel();}catch(e){}
    }
    window.addEventListener('resize',refreshCollectionPosition,{passive:true});
    window.addEventListener('scroll',refreshCollectionPosition,{passive:true});

    if(collectionRoot&&collectionPanel){
      collectionRoot.addEventListener('mouseleave',function(){
        if(window.innerWidth<=768)return;
        try{if(collectionPanel.matches(':popover-open'))collectionPanel.hidePopover();}catch(e){}
      });
    }

    /* Header auto-hide — preserved behavior. */
    var last=window.scrollY||0;
    var anchor=last;
    var ticking=false;
    var threshold=55;
    var forcedVisibleUntil=0;
    var forcedRestoreHidden=false;
    var forcedRevealTimer=0;

    function headerMenuOpen(){
      var dotsOpen=false;
      var collectionOpen=false;
      try{dotsOpen=Boolean(dots&&dots.matches(':popover-open'));}catch(e){}
      try{collectionOpen=Boolean(collectionPanel&&collectionPanel.matches(':popover-open'));}catch(e){}
      return dotsOpen||collectionOpen||Boolean(mobile&&mobile.classList.contains('is-open'));
    }

    function updateHeader(){
      var y=window.scrollY||0;
      if(Date.now()<forcedVisibleUntil){
        if(shell)shell.classList.remove('is-hidden');
        last=y;
        ticking=false;
        return;
      }
      if(headerMenuOpen()){
        if(shell)shell.classList.remove('is-hidden');
        anchor=y;
        last=y;
        ticking=false;
        return;
      }
      if(shell){
        if(y<70){shell.classList.remove('is-hidden');anchor=y;}
        else if(y<last){shell.classList.remove('is-hidden');anchor=y;}
        else if(y-anchor>threshold){shell.classList.add('is-hidden');}
      }
      if(Math.abs(y-last)>threshold)anchor=y;
      last=y;
      ticking=false;
    }

    function revealHeaderForAction(event){
      if(!shell)return;
      var detail=event&&event.detail?event.detail:{};
      var requested=parseInt(detail.duration,10);
      var duration=Number.isFinite(requested)?Math.max(900,Math.min(3500,requested)):2200;
      var wasHidden=shell.classList.contains('is-hidden');
      if(forcedRevealTimer){clearTimeout(forcedRevealTimer);forcedRevealTimer=0;}
      forcedRestoreHidden=forcedRestoreHidden||wasHidden;
      forcedVisibleUntil=Date.now()+duration;
      shell.classList.remove('is-hidden');
      requestAnimationFrame(function(){
        document.dispatchEvent(new CustomEvent('bdf:header:revealed',{detail:{reason:detail.reason||'',wasHidden:wasHidden}}));
      });
      forcedRevealTimer=window.setTimeout(function(){
        forcedRevealTimer=0;
        forcedVisibleUntil=0;
        var y=window.scrollY||0;
        if(forcedRestoreHidden&&y>=70&&!headerMenuOpen())shell.classList.add('is-hidden');
        forcedRestoreHidden=false;
        anchor=y;
        last=y;
      },duration);
    }

    document.addEventListener('bdf:header:reveal',revealHeaderForAction);

    window.addEventListener('scroll',function(){
      if(!ticking){requestAnimationFrame(updateHeader);ticking=true;}
    },{passive:true});

    window.addEventListener('resize',function(){
      if(window.innerWidth>768&&mobile&&mobile.classList.contains('is-open'))setMobile(false);
    },{passive:true});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();